export const TOP_BAR_HEADING_SPRING_CONFIG = {
  from: { x: -400, opacity: 0 },
  to: { x: 0, opacity: 1 },
  delay: 400,
};

export const FIRST_DESCRIPTION_SPRING_CONFIG = {
  from: { opacity: 0 },
  to: { opacity: 1 },
  delay: 400,
};
